module.exports = __webpack_public_path__ + "static/media/jio.bedaecd2.png";